import React from 'react';
import { Text } from '@web-for-marketing/react-ui';
import { TableOfContentV2Styles as classes } from './TableOfContentsV2Styles';
import { TableOfContentsHeading } from '@models/tableOfContents';

interface TableOfContentsMobileItemsProps {
    items: TableOfContentsHeading[];
    onSelectItem: (id: string, event: React.MouseEvent<HTMLElement>) => void;
    activeHeader: string | null;
}

export function TableOfContentsMobileItems({
    items,
    onSelectItem,
    activeHeader,
}: TableOfContentsMobileItemsProps): JSX.Element {
    const renderTableItem = (elem: TableOfContentsHeading): JSX.Element => {
        const isActive = activeHeader === elem.id;

        return (
            <li key={elem.id}>
                <Text
                    variant='body2'
                    color={isActive ? 'activePrimary' : 'secondary'}
                    weight={isActive ? 'medium' : 'regular'}
                    component='a'
                    href={`#${elem.id}`}
                    css={classes.linkStylesMobile}
                    onClick={(event: React.MouseEvent<HTMLElement>) => onSelectItem(elem.id, event)}
                    dangerouslySetInnerHTML={{ __html: elem.title || '' }}
                ></Text>
                {elem.items && elem.items.length > 0 ? (
                    <ul css={classes.listUlMobile}>{elem.items.map((child) => renderTableItem(child))}</ul>
                ) : null}
            </li>
        );
    };

    return <>{items.map((elem) => renderTableItem(elem))}</>;
}
